module.exports = __webpack_public_path__ + "static/white_logo_cropped-b417a8114f3f63983e33001396bf3273.png";